export const CHAT_STREAM_TICK_MS = 16;
export const CHAT_STREAM_CHARS_PER_TICK = 2;

/** Turn backend escape sequences (e.g. "\\n") into real whitespace for display. */
export const normalizeChatMessageText = (text) => {
  if (text == null) return '';
  return String(text)
    .replace(/\\r\\n/g, '\n')
    .replace(/\\n/g, '\n')
    .replace(/\\r/g, '\n')
    .replace(/\\t/g, '\t');
};

export const getNextStreamSlice = (
  fullText = '',
  currentLength = 0,
  charsPerTick = CHAT_STREAM_CHARS_PER_TICK
) => {
  const safeText = String(fullText);
  const nextLength = Math.min(currentLength + charsPerTick, safeText.length);

  return {
    text: safeText.slice(0, nextLength),
    isComplete: nextLength >= safeText.length,
    nextLength,
  };
};
